// extracted by mini-css-extract-plugin
export default {"warningIconWrapper":"NotUsingRolePermissionsWarningComponent_warningIconWrapper__rZP8M","warningWrapper":"NotUsingRolePermissionsWarningComponent_warningWrapper__1Rukl"};